export const PROFILE_NAME = "Lina Fernanda Orozco Jimenez";
export const PROFILE_TITLE = "Abogada";
export const PROFILE_SPECIALTY = "Derecho Comercial & Civil";
export const PROFILE_LOCATION = "Bogota";
